import { PortalContainerProvider } from '@crono-one/design-system';
import FormSection from 'components/CreationForms/base/FormSection';
import { List, ListType } from 'crono-fe-common/types/list';
import ListDropdown from 'pages/lists/Lists/ListDropdown';

export interface ListSectionProps {
  listType: ListType.Prospect | ListType.Lead | ListType.Account;
  selectedList: List | null;
  onChange: (list: List | null) => void;
}

/** "Add to list" block of the creation forms. */
const ListSection = ({
  listType,
  selectedList,
  onChange,
}: ListSectionProps) => (
  <FormSection title="Add to list">
    <div className="relative">
      {/* Its "Create list" dialog opens over the whole page, not inside the
          portal container of whatever surrounds the section. */}
      <PortalContainerProvider container={null}>
        <ListDropdown
          selectedList={selectedList}
          setSelectedList={onChange}
          listType={listType}
          dropdownWidth="100%"
          inset="100% auto auto auto"
          customEmptyText="Select list..."
          size="sm"
        />
      </PortalContainerProvider>
    </div>
  </FormSection>
);

export default ListSection;
